export class DeviceGroup {
    id: number;
    created_datetime:  Date;
    lastupdated_datetime: Date;
    name:  string;
    desc:  string;
    code: string;
    status:  number;
    status_str: string;
}
export class ReqAddDeviceGroup {
    name: number;
    status: number;
    code: string;
    desc: string;
}
